import React from 'react';
// mui
import { VoicemailOutlined } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';
// components
import AudioPlayer from 'src/components/AudioPlayer';
import CallLog from 'src/components/CallLog';
// hooks
import { useSnackbar } from 'notistack';
import useVoicemail, { Voicemail as VoicemailInterface } from 'src/hooks/core-api/useVoicemail';

interface VoicemailProps {
  voicemail: VoicemailInterface;
}

const Voicemail: React.FC<VoicemailProps> = ({ voicemail }) => {
  const { refetch, error } = useVoicemail(voicemail.id, { enabled: false });
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();

  const primaryText = theme.palette.text.primary;

  if (error) {
    enqueueSnackbar('Failed to load voicemail', { variant: 'error' });
  }

  return (
    <CallLog
      log={{
        from: voicemail.from_formatted,
        label: voicemail.location_name,
        direction: 'inbound',
        callEndTime: voicemail.created_on,
        duration: voicemail.duration,
      }}
    >
      <Box sx={{ mt: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
            p: 1,
          }}
        >
          <VoicemailOutlined sx={{ mr: 2, color: primaryText, fontSize: 20 }} />
          <Typography variant="body2" sx={{ color: primaryText, pa: 0, ma: 0 }}>
            {voicemail.transcript}
          </Typography>
        </Box>

        <Box sx={{ my: 1 }}>
          <AudioPlayer
            onGetUrl={async () => {
              const { data } = await refetch();
              if (data?.voicemail_link) {
                return data.voicemail_link;
              }

              return '';
            }}
          />
        </Box>
      </Box>
    </CallLog>
  );
};

export default Voicemail;
